import { render, staticRenderFns } from "./EmployeeRequests.vue?vue&type=template&id=8ea85c52&scoped=true"
import script from "./EmployeeRequests.vue?vue&type=script&lang=js"
export * from "./EmployeeRequests.vue?vue&type=script&lang=js"
import style0 from "./EmployeeRequests.vue?vue&type=style&index=0&id=8ea85c52&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8ea85c52",
  null
  
)

export default component.exports